/** @graphql cc **/

import gql from 'graphql-tag';

export const PersonalSpaceDetailQuery = gql`
	query PersonalSpaceDetailQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				space {
					id
					key
					dataClassificationTags
				}
			}
		}
	}
`;
